// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-payment-preview--container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 8px; }\n", ""]);
// Exports
module.exports = exports;
